import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Application } from '../types';

interface ApplicationContextType {
  applications: Application[];
  addApplication: (application: any) => void;
  updateApplicationStatus: (id: string, status: Application['status']) => void;
  getApplicationsByStudent: (studentId: string) => Application[];
  getApplicationsByCourse: (courseId: string) => Application[];
  cancelApplication: (id: string) => void;
}

const ApplicationContext = createContext<ApplicationContextType | undefined>(undefined);

// NOTE: This context is deprecated in favor of Edge Functions
// Kept for backward compatibility with admin pages
export const ApplicationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [applications] = useState<Application[]>([]);

  const addApplication = (applicationData: any) => {
    // Deprecated: Use submitApplication from applicationService instead
    console.warn('ApplicationContext.addApplication is deprecated. Use submitApplication from applicationService.');
  };

  const updateApplicationStatus = (id: string, status: Application['status']) => {
    // Deprecated
    console.warn('ApplicationContext.updateApplicationStatus is deprecated.');
  };

  const getApplicationsByStudent = (studentId: string) => {
    // Deprecated: Use getMyApplications from applicationService instead
    return [];
  };

  const getApplicationsByCourse = (courseId: string) => {
    // Deprecated
    return [];
  };

  const cancelApplication = (id: string) => {
    // Deprecated: Use cancelApplication from applicationService instead
    console.warn('ApplicationContext.cancelApplication is deprecated. Use cancelApplication from applicationService.');
  };

  return (
    <ApplicationContext.Provider value={{
      applications,
      addApplication,
      updateApplicationStatus,
      getApplicationsByStudent,
      getApplicationsByCourse,
      cancelApplication
    }}>
      {children}
    </ApplicationContext.Provider>
  );
};

export const useApplications = () => {
  const context = useContext(ApplicationContext);
  if (context === undefined) {
    throw new Error('useApplications must be used within an ApplicationProvider');
  }
  return context;
};